<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex d-flex xs12 sm3 child-flex>
          <v-layout row wrap>
            <v-flex>
              <v-card>
                <v-card-text>
                  <v-layout row wrap align-center justify-center>
                    <h3>Book New Shipment </h3>
                    <v-dialog
                      v-model="dialog"
                      width="800"
                    >
                      <v-btn fab dark small color="primary" slot="activator" style="margin-left:20px">
                        <v-icon dark>add</v-icon>
                      </v-btn>
                      <v-card>
                        <v-card-title
                          class="headline lighten-2"
                          primary-title
                          style="color:#1565C0"
                        >
                          Select Service
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-layout row wrap>
                                <v-radio-group v-model="radioGroup">
                                  <v-radio
                                    :label="`Back to Back(B2B)`"
                                    :value="B2B"
                                  ></v-radio>
                                  <v-radio
                                    :label="`HUB`"
                                    :value="HUB"
                                  ></v-radio>
                                </v-radio-group>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs12 child-flex>
                              <v-layout row wrap>
                                <v-flex xs4>
                                  <v-overflow-btn
                                    :items="dropdown_freight"
                                    label="Freight Forwarding"
                                    target="#dropdown-example"
                                    v-on:change="freightair"
                                  ></v-overflow-btn>
                                </v-flex>
                                <v-flex xs4>
                                  <v-overflow-btn
                                    :items="dropdown_inland"
                                    label="Inland Logistics Management"
                                    target="#dropdown-example"
                                    v-on:change="inlandlogistics"
                                    style="margin-left:10px"
                                  ></v-overflow-btn>
                                </v-flex>
                                <v-flex xs4>
                                  <v-overflow-btn
                                    :items="dropdown_custom"
                                    label="Custom Clearance"
                                    target="#dropdown-example"
                                    v-on:change="customclearanceform"
                                    style="margin-left:10px"
                                  ></v-overflow-btn>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>

                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            flat
                            @click="dialog = false"
                          >
                            Close
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex style="margin-top:20px">
              <v-card>
                <v-card-text>
                  <v-layout row wrap align-center justify-center>
                    <h3>Bulk Booking</h3>
                    <v-btn fab dark small color="primary" style="margin-left:20px">
                      <v-icon dark v-on:click="bulkbooking()">cloud_upload</v-icon>
                    </v-btn>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex style="margin-top:20px">
              <v-card>
                <v-card-text>
                  <h3 style="text-align: left;margin-bottom: 10px">Track Your Shipment</h3>
                  <v-divider divider: true></v-divider>
                  <v-text-field
                    label="Booking No, Container No, Trip No."
                    outline
                    style="margin-top:20px"
                  ></v-text-field>
                  <v-btn class="primary" v-on:click="search()">Search</v-btn>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex d-flex xs12 sm9>
          <v-layout row wrap>
            <v-flex d-flex>
               <v-flex>
                  <v-card style="margin-left:30px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Container Management</h3>
                      <v-divider divider: true></v-divider>
                      <p style="color:#1565C0;text-align: center;font-size:30px;margin-top: 20px">40</p>
                      <p style="margin-top:10px;text-align: center">No. of Containers on Detention Charges</p>
                      <p style="margin-top:10px;text-align: right;"><a>View Details</a></p>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs5>
                  <v-card style="margin-left:30px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Hub Management</h3>
                      <v-divider divider: true></v-divider>
                      <v-layout>
                        <v-flex xs6 child-flex>
                          <p style="color:#1565C0;text-align: center;font-size:30px;margin-top: 20px">500</p>
                          <p style="margin-top:10px;text-align: center">No. of Containers of Hub Stations</p>
                        </v-flex>
                        <v-divider vertical></v-divider>
                        <v-flex xs6 child-flex>
                          <p style="color:#1565C0;text-align: center;font-size:30px;margin-top: 20px">73</p>
                          <p style="margin-top:10px;text-align: center">No. of Containers on Detention Charges</p>
                        </v-flex>
                      </v-layout>
                      <p style="margin-top:0px;text-align: right;"><a>View Details</a></p>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex>
                  <v-card style="margin-left:30px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Warehouse Management</h3>
                      <v-divider divider: true></v-divider>
                      <p style="color:#1565C0;text-align: center;font-size:30px;margin-top: 20px">3681 Tons</p>
                      <p style="margin-top:10px;text-align: center">Total Weight including All Warehouse</p>
                      <p style="margin-top:15px;text-align: right;"><a>View Details</a></p>
                    </v-card-text>
                  </v-card>
                </v-flex>
            </v-flex>
            <v-flex d-flex>
              <v-layout row>
                <v-flex d-flex style="margin-top:20px">
                  <v-flex xs6>
                    <v-card style="margin-left:30px">
                      <v-card-text>
                        <h3 style="text-align: left;margin-bottom: 10px">Shipping Instructions</h3>
                        <v-divider divider: true></v-divider>
                        <v-layout>
                          <v-flex xs3 child-flex>
                            <p style="color:#1565C0;text-align: center;font-size:30px;margin-top: 20px">05</p>
                            <p style="margin-top:10px;text-align: center">Pending SI</p>
                          </v-flex>
                          <v-divider vertical></v-divider>
                          <v-flex xs4 child-flex>
                            <p style="color:#1565C0;text-align: center;font-size:30px;margin-top: 20px">10</p>
                            <p style="margin-top:10px;text-align: center">Submitted SI</p>
                          </v-flex>
                          <v-divider vertical></v-divider>
                            <v-flex xs6 child-flex>
                              <p style="color:#1565C0;text-align: center;font-size:30px;margin-top: 20px">10</p>
                              <p style="margin-top:10px;text-align: center">Approve Verify Copy SI</p>
                            </v-flex>
                        </v-layout>
                        <!--<p style="margin-top:0px;text-align: right;"><a>View Details</a></p>-->
                        <p style="margin-top:0px;text-align: right;"><router-link v-bind:to="'shippinginstructionsoverview'">View Details</router-link></p>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs6>
                    <v-card style="margin-left:30px">
                      <v-card-text>
                        <h3 style="text-align: left;margin-bottom: 10px">My Booking</h3>
                        <v-divider divider: true></v-divider>
                        <v-layout>
                          <v-flex xs6 child-flex>
                            <p style="color:#1565C0;text-align: center;font-size:30px;margin-top: 20px">10</p>
                            <p style="margin-top:10px;text-align: center">Confirm</p>
                          </v-flex>
                          <v-divider vertical></v-divider>
                          <v-flex xs6 child-flex>
                            <p style="color:#1565C0;text-align: center;font-size:30px;margin-top: 20px">02</p>
                            <p style="margin-top:10px;text-align: center">Cancel/ Decline</p>
                          </v-flex>
                          <v-divider vertical></v-divider>
                            <v-flex xs4 child-flex>
                              <p style="color:#1565C0;text-align: center;font-size:30px;margin-top: 20px">02</p>
                              <p style="margin-top:10px;text-align: center">Pending</p>
                            </v-flex>
                        </v-layout>
                        <p style="margin-top:0px;text-align: right;"><a>View Details</a></p>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex d-flex xs12 style="margin-top: 20px">
          <v-layout column>
            <v-flex d-flex>
              <v-card style="">
                <v-card-text>
                  <h3 style="text-align: left;margin-bottom: 10px">Recent Booking List</h3>
                  <v-divider divider: true></v-divider>
                  <v-layout row wrap>
                    <v-flex xs3 child-flex>
                      <v-layout row wrap>
                        <label style="margin-top:20px;margin-right: 10px">Show</label>
                        <v-overflow-btn
                          :items="dropdown_list"
                          label=""
                          target="#dropdown-example"
                        ></v-overflow-btn>
                        <label style="margin-top:20px;margin-left: 10px">Entries</label>
                      </v-layout>
                    </v-flex>
                    <v-flex xs3 child-flex></v-flex>
                    <v-flex xs6 child-flex>
                      <v-layout row wrap>
                        <v-text-field
                          label="Search"
                        ></v-text-field>
                        <v-btn class="primary" flat style="margin-top:10px;"><v-icon dark>search</v-icon></v-btn>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-data-table
                    :headers="headers"
                    :items="desserts"
                    class="elevation-1"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.no}}</td>
                      <td class="text-xs-left">{{ props.item.calories }}</td>
                      <td class="text-xs-left">{{ props.item.fat }}</td>
                      <td class="text-xs-left">{{ props.item.carbs }}</td>
                      <td class="text-xs-left">{{ props.item.protein }}</td>
                      <td class="text-xs-left">{{ props.item.iron }}</td>
                      <td class="text-xs-left">{{ props.item.status }}</td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      dropdown_list: [1, 2, 3, 4, 5],
      dropdown_freight: ['Air Freight - Export', 'Air Freight - Import', 'Sea Freight - Export - Containerized', 'Sea Freight - Export - ISO Tank', 'Sea Freight - Export - BreakBulk', 'Sea Freight - Export - Project Cargo', 'Sea Freight - Export - RORO', 'Sea Freight - Import - Containerized', 'Sea Freight - Import - ISO Tank', 'Sea Freight - Import - BreakBulk', 'Sea Freight - Import - Project Cargo', 'Sea Freight - Import - RORO'],
      dropdown_custom: ['Export- Air Freight', 'Export- Inland Freight', 'Export- Sea Freight', 'Import- Air Freight', 'Import- Inland Freight', 'Import- Sea Freight'],
      dropdown_inland: ['Domestic', 'International'],
      customclearance: '',
      freight: '',
      headers: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Booking No', value: 'calories' },
        { text: 'From', value: 'fat' },
        { text: 'To', value: 'carbs' },
        { text: 'Booking Date', value: 'protein' },
        { text: 'ETA', value: 'iron' },
        { text: 'Status', value: 'status' }
      ],
      desserts: [
        {
          no: '1',
          calories: 'AME/FF/17081001',
          fat: 'Mumbai,India',
          carbs: 'USA',
          protein: '18-AUG-2017',
          iron: '22-SEPT-2017',
          status: 'In Progress'
        },
        {
          no: '2',
          calories: 'AME/FF/17081003',
          fat: 'Mumbai,India',
          carbs: 'USA',
          protein: '18-AUG-2017',
          iron: '22-SEPT-2017',
          status: 'In Progress'
        },
        {
          no: '3',
          calories: 'AME/FF/17081083',
          fat: 'Mumbai,India',
          carbs: 'USA',
          protein: '18-AUG-2017',
          iron: '22-SEPT-2017',
          status: 'In Progress'
        }
      ],
      dialog: false,
      radioGroup: 1,
      B2B: true,
      HUB: false
    }
  },
  mounted () {
    console.log('dashboard page')
    if (this.freight === 'Air Freight') {
      this.$router.push('/Freightforwardingbookingform')
    }
    if (this.customclearance === 'Export') {
      this.$router.push('/Customclearancebookingform')
    }
  },
  methods: {
    bulkbooking () {
      this.$router.push('/Bulkbooking')
    },
    search () {
      this.$router.push('/Trackyourshipment')
    },
    freightair () {
      this.$router.push('/Freightforwardingbookingform')
    },
    customclearanceform () {
      this.$router.push('/Customclearancebookingform')
    },
    inlandlogistics () {
      this.$router.push('/Truckingaddregions')
    },
    setSelectedItem (item) {
      this.selectedDropdown = item
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue